import React, { useEffect, useState } from "react";
import { Spin } from "antd";
import { Field, FormikProvider, useFormik } from "formik";
import { Col, Form, Row } from "react-bootstrap";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import moment from "moment";
import { post } from "../../../helpers/api_helper";
import {
  POST_GetCustomerDDLListAJAX,
  POST_GetReportPendingInvoiceExport,
  POST_GetReportPendingInvoiceList,
} from "../../../helpers/url_helper";
import { errorMessage } from "../CommonFunctions";
import CustomSelectAsync from "../../../CustomControls/CustomSelectAsync";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";
import CustomSelect from "../../../CustomControls/CustomSelect";
import CustomInput from "../../../CustomControls/CustomInput";

const PendingInvoice = () => {
  const [showFilter, setShowFilter] = useState(true); //for report screen default true
  const [isLoading, setIsLoading] = useState(false);

  const [isReset, setIsReset] = useState(false);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  const [pendingInvoiceList, setPendingInvoiceList] = useState([]);

  const invoiceStatusOptions = [
    { label: "All", value: -1 },
    { label: "Pending", value: 0 },
    { label: "Generated", value: 1 },
    { label: "Partial Generated", value: 2 },
  ];

  const validationSchemaFilter = Yup.object().shape({});

  const formikFilter = useFormik({
    validationSchema: validationSchemaFilter,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitFilter(values, formikHelpers),
    initialValues: {
      InwardNo: "",
      FromDate: new Date(),
      ToDate: new Date(),
      CustomerIDEncrypted: "",
      CustomerName: "",
      InvoiceStatus: -1,
    },
    validateOnBlur: false,
  });

  const {
    values: {
      InwardNo,
      FromDate,
      ToDate,
      CustomerIDEncrypted,
      CustomerName,
      InvoiceStatus,
    },
  } = formikFilter;

  const handleValidSubmitFilter = (values) => {
    getData();
  };

  const getResetData = async () => {
    setIsLoading(true);

    // formikFilter.resetForm();
    formikFilter.setValues({
      InwardNo: "",
      FromDate: new Date(),
      ToDate: new Date(),
      CustomerIDEncrypted: "",
      CustomerName: "",
      InvoiceStatus: -1,
    });

    setIsReset(true);
  };

  useEffect(() => {
    if (ToDate && ToDate < FromDate) {
      formikFilter.setFieldValue("ToDate", FromDate);
    }
  }, [FromDate]);

  useEffect(() => {
    if (isReset == true) {
      getData();
      setIsReset(false);
    }
  }, [isReset]);

  const getData = async () => {
    setIsLoading(true);

    let payload = {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      InwardNo: InwardNo,
      FromDate: FromDate
        ? moment(FromDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      ToDate: ToDate
        ? moment(ToDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      CustomerIDEncrypted: CustomerIDEncrypted,
      InvoiceStatus: InvoiceStatus,
    };

    await post(POST_GetReportPendingInvoiceList, payload)
      .then((response) => {
        setPendingInvoiceList(response?.List);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });

    setIsLoading(false);
  };

  const exportReport = () => {
    setIsLoading(true);
    let payload = {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      InwardNo: InwardNo,
      FromDate: FromDate
        ? moment(FromDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      ToDate: ToDate
        ? moment(ToDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      CustomerIDEncrypted: CustomerIDEncrypted,
      InvoiceStatus: InvoiceStatus,
      ReportGenerateByIDEncrypted: AuthUser?.ReferenceIDEncrypt,
    };

    post(POST_GetReportPendingInvoiceExport, payload)
      .then((response) => {
        if (response?.IsSuccess) {
          window.open(response?.FilePath);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getCustomerDDL_AJAX = async (inputValue) => {
    return await post(POST_GetCustomerDDLListAJAX, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      SearchValue: inputValue ?? "",
      TPIFlag: -1, // 0 = Only Customer, 1 = Only TPI,  -1 = All (Customer & TPI both)
    })
      .then((response) => {
        if (response?.IsSuccess) {
          return response?.CustomerDDLList?.map((item) => ({
            label: item.CustomerName,
            value: item.CustomerIDEncrypted,
          }));
        } else {
          return [];
        }
      })
      .catch((error) => {
        console.log(error);
        return [];
      });
  };

  const loadOptionsCustomer = (inputValue) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(getCustomerDDL_AJAX(inputValue));
      }, 1000);
    });
  };

  return (
    <>
      <div className="card m-1">
        <div className="card-body p-1">
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div className="table-responsive active-projects style-1 shorting">
              <div className="tbl-caption p-2">
                <h4 className="heading mb-0">Pending Invoice</h4>
                <div className="d-flex align-items-center">
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={(e) => {
                      getResetData();
                    }}
                  >
                    <i className="fa fa-window-restore me-2" aria-hidden="true"></i>
                    Reset
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={() => setShowFilter(!showFilter)}
                  >
                    <i className="fa-solid fa-filter me-2"></i>Filter
                  </button>
                  {AuthUser?.UserType !== 1 ||
                  formsList?.filter((x) => x?.FormID == 59 && x?.IsExport)
                    ?.length > 0 ? (
                    <Link
                      className="btn btn-outline-primary btn-sm me-2"
                      onClick={exportReport}
                    >
                      <i className="fa-solid fa-file-excel" /> Export Report
                    </Link>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <hr className="mt-0 mb-1"></hr>
              <div className="p-2 pt-0 pb-0">
                {showFilter ? (
                  <div>
                    <FormikProvider value={formikFilter}>
                      <Form onSubmit={formikFilter.handleSubmit}>
                        <Row className="me-0">
                          <Col lg={2}>
                            <Field
                              label="Inward No"
                              name="InwardNo"
                              placeholder={"Search Inward No"}
                              component={CustomInput}
                            />
                          </Col>

                          <Col lg={2}>
                            <label className="mb-1">Inward Date</label>
                            <div className="d-flex">
                              <Field
                                name="FromDate"
                                placeholder={"From Date"}
                                component={CustomFlatpickr}
                                options={{
                                  altInput: true,
                                  altFormat: "j-M-Y",
                                  dateFormat: "d-m-Y",
                                }}
                              />
                              <div>&nbsp;</div>
                              <Field
                                name="ToDate"
                                placeholder={"To Date"}
                                component={CustomFlatpickr}
                                options={{
                                  altInput: true,
                                  altFormat: "j-M-Y",
                                  dateFormat: "d-m-Y",
                                  minDate: FromDate,
                                }}
                              />
                            </div>
                          </Col>

                          <Col lg={3}>
                            <Field
                              label="Customer"
                              name="CustomerIDEncrypted"
                              placeholder={"Select Customer"}
                              loadOptionsFn={loadOptionsCustomer}
                              component={CustomSelectAsync}
                              title={CustomerName}
                              labelFieldName="CustomerName"
                              // menuPosition="fixed"
                            />
                          </Col>

                          <Col lg={2}>
                            <Field
                              label="Invoice Status"
                              name="InvoiceStatus"
                              placeholder={"Select Invoice Status"}
                              options={invoiceStatusOptions}
                              component={CustomSelect}
                              isClearable={false}
                              // menuPosition="fixed"
                            />
                          </Col>

                          <Col lg={1}>
                            <label className="mb-1">&nbsp;</label>
                            <div className="d-flex">
                              <div className="d-lg-block">
                                <button
                                  className="btn btn-primary btn-sm mb-1"
                                  type="submit"
                                >
                                  <i
                                    className="fa fa-search"
                                    aria-hidden="true"
                                  ></i>
                                  {"  "} Search
                                </button>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </FormikProvider>
                  </div>
                ) : (
                  ""
                )}
                <div className="table-responsive">
                  <div
                    id="PendingInvoice-tbl_wrapper"
                    className="dataTables_wrapper no-footer"
                    style={{ height: "510px", overflowY: "auto" }}
                  >
                    <table
                      id="PendingInvoice-tbl"
                      className="table dataTable no-footer mb-0"
                    >
                      <thead className="fixedheader">
                        <tr>
                          <th
                            width="2%"
                            style={{ minWidth: "50px", textAlign: "center" }}
                          >
                            #
                          </th>
                          <th width="7%" style={{ minWidth: "120px" }}>
                            Inward No
                          </th>
                          <th width="7%" style={{ minWidth: "120px" }}>
                            Inward Date
                          </th>
                          <th width="12%" style={{ minWidth: "200px" }}>
                            TC No
                          </th>
                          <th width="18%" style={{ minWidth: "200px" }}>
                            Customer Name
                          </th>
                          <th width="12%" style={{ minWidth: "160px" }}>
                            Contact Person
                          </th>
                          <th width="7%" style={{ minWidth: "120px" }}>
                            Proforma Invoice No
                          </th>
                          <th width="7%" style={{ minWidth: "120px" }}>
                            Proforma Date
                          </th>
                          <th width="7%" style={{ minWidth: "120px" }}>
                            Proforma Amount
                          </th>
                          <th width="7%" style={{ minWidth: "120px" }}>
                            Invoice No
                          </th>
                          <th width="7%" style={{ minWidth: "120px" }}>
                            Invoice Date
                          </th>
                          <th
                            width="7%"
                            style={{ minWidth: "120px", textAlign: "right" }}
                          >
                            Invoice Amount
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {pendingInvoiceList?.length > 0 ? (
                          <>
                            {pendingInvoiceList?.map((item, index) => (
                              <tr key={index}>
                                <td style={{ textAlign: "center" }}>
                                  {item?.RowNo}
                                </td>
                                <td>{item?.InwardNo}</td>
                                <td>{item?.InwardDate}</td>
                                <td>{item?.TCNo}</td>
                                <td
                                  style={{
                                    whiteSpace: "normal",
                                  }}
                                >
                                  {item?.CustomerName}
                                </td>
                                <td
                                  style={{
                                    whiteSpace: "normal",
                                  }}
                                >
                                  {item?.ContactPerson}
                                </td>
                                <td>{item?.PerformaInvoiceNo}</td>
                                <td>{item?.PerformaInvoiceDate}</td>
                                <td style={{ textAlign: "right" }}>
                                  {item?.PerformaInvoiceAmount}
                                </td>
                                <td>{item?.InvoiceNo}</td>
                                <td>{item?.InvoiceDate}</td>

                                <td style={{ textAlign: "right" }}>
                                  {item?.InvoiceAmount}
                                </td>
                              </tr>
                            ))}
                          </>
                        ) : (
                          <tr>
                            <td colSpan={12} style={{ textAlign: "left" }}>
                              <div>{"No Record Found..."}</div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </Spin>
        </div>
      </div>
    </>
  );
};

export default PendingInvoice;
